import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { getAllCustomer, toggleCustomer } from "../../actions/CustomerActions";
import Webmenu from "../../layouts/webmenu";
import Topbar from "../../layouts/topbar";
import DataTable from "react-data-table-component";
import { ThreeDots } from "react-loader-spinner";
import { getAllDriver, toggleDriver } from "../../actions/DriverActions";
import { getAllUsers } from "../../actions/UserActions";
import Mobilemenu from "../../layouts/mobile-menu";

function Users() {

    const dispatch = useDispatch();

    const [page, setPage] = useState(1);
    const [currentRowsPerPage, setCurrentRowsPerPage] = useState(10);

    useEffect(() => {
        dispatch(getAllUsers(page, currentRowsPerPage, filter ?? ''));
    }, [currentRowsPerPage])

    const onChangePage = (page) => {
        // page)
        dispatch(getAllUsers(page, currentRowsPerPage, filter ?? ''));
    }

    // const toggleStatus = (id) => {
    //     dispatch(toggleDriver(id));
    // }

    const users = useSelector(state => state?.users?.users?.data?.data);
    const usersPagination = useSelector(state => state?.users?.users?.total);
    const loading = useSelector(state => state?.loading?.loading);
    const user_permissions = JSON.parse(localStorage.getItem('perm'));

    const customStyles = {
        table: {
            style: {
                backgroundColor: 'rgb(241, 245, 248)',
            },
        },
        headRow: {
            style: {
                border: 'none !important'
            }
        },
        head: {
            style: {
                fontWeight: 'bold',
                fontSize: '14px',
                border: 'none !important',
            }
        },
        rows: {
            style: {
                minHeight: '60px', // override the row height
                backgroundColor: '#fff !important',
                borderTop: 'none !important',
                marginBottom: '10px',
                borderRadius: '30px',
                paddingRight: '5px',
                '&:not(:last-of-type)': {
                    border: 'none'
                }
            },
        },
        body: {
            style: {
                backgroundColor: 'rgb(241, 245, 248)',
            }
        },
        headCells: {
            style: {
                paddingLeft: '20px', // override the cell padding for head cells
                paddingRight: '20px',
                fontSize: '14px',
                fontWeight: '700',
                textTransform: 'uppercase',
                border: 'none !important',
                backgroundColor: 'rgb(241, 245, 248)',
                // justifyContent: 'center'
            },
        },
        cells: {
            style: {

                fontSize: '14px',
                // 'div:first-child': {
                //     overflow: 'visible !important'
                // }
                // justifyContent: 'center'
            },
        },
        pagination: {
            style: {
                backgroundColor: 'rgb(241,245,248)',
                borderTop: 'none !important',
            },
        }
    };
    const columns = [
        {
            name: 'ID',
            selector: row => row.user_id,
            width: '20%'
        },
        {
            name: 'NAME',
            selector: row => row.user_name,
        },
        {
            name: 'EMAIL',
            // selector: 'driver@gmail.com',
            selector: row => row.email_address,
            // width: '60%'
        },
        // {
        //     name: 'MOBILE',
        //     selector: row => row.phone_sanitized,
        // },
        // {
        //     name: 'STATUS',
        //     selector: row => <div className="d-flex align-items-center form-check form-switch">
        //         <input onChange={(e) => toggleStatus(row.customer_id)} type="checkbox"
        //             defaultChecked={row.status} className="form-check-input" />
        //     </div>,
        // },
        {

            selector: row => (
                user_permissions.some(item => item.permission_id == '30') ? (
                    <div className="dropdown" >
                        <button className="dropdown-toggle btn px-2 box text-gray-700 dark-text-gray-300" aria-expanded="false" data-bs-toggle="dropdown">
                            <span className="d-flex align-items-center fs-base justify-content-center">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-settings me-1 w-6 h-6"><circle cx="12" cy="12" r="3"></circle><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path></svg>
                                Actions
                            </span>
                        </button>
                        <div className="dropdown-menu w-40">
                            <div className="dropdown-content">
                                <Link className="d-flex align-items-center fs-base py-1" to={`/user/permissions/${row.user_id}`}> <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="feather feather-edit me-1 w-6 h-6"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path></svg> Permissions </Link>
                                <Link className="d-flex align-items-center fs-base py-1" to={`/user/edit/${row.user_id}`}> <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="feather feather-edit me-1 w-6 h-6"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path></svg> Edit </Link>
                            </div>
                        </div>
                    </div >
                ) : null
            )
        },
    ];

    const [filter, setFilter] = useState('');

    const handleFilter = (event) => {
        setFilter({
            ...filter,
            [event.target.name]: event.target.value,
        })
    }

    const handleClearFilter = () => {
        setFilter('')
        dispatch(getAllUsers(page, currentRowsPerPage, ''))
    }

    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            filterSearch();
        }
    }

    const filterSearch = () => {
        dispatch(getAllUsers(page, currentRowsPerPage, filter ?? ''))
    }
    return (

        <React.Fragment>
            <Mobilemenu />
            <div className="content-body d-flex">
                <Webmenu />
                <div className="content">
                    <Topbar />
                    <span>
                        <div className="intro-y g-col-12 d-flex flex-wrap flex-sm-nowrap align-items-center mt-5">
                            {/* <h2 className="intro-y fs-lg fw-medium me-3">
                                Users
                            </h2> */}
                            {
                                user_permissions.some(item => item.permission_id == '30') &&
                                <Link to="/user/add">
                                    <button className="btn btn-primary shadow-md me-3">Add New</button>
                                </Link>
                            }
                            {/* <button class="btn btn-primary ms-auto d-flex align-items-center dark-text-theme-10" type="button"
                                        data-bs-toggle="collapse" data-bs-target="#faq-accordion-collapse-1" aria-expanded="true"
                                        aria-controls="faq-accordion-collapse-1">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-filter w-4 h-4 me-3"><polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"></polygon></svg>
                                        Filters </button> */}
                        </div>
                        <div id="faq-accordion-collapse-1" class="accordion-collapse collapse show mt-5" aria-labelledby="faq-accordion-content-1"
                            data-bs-parent="#faq-accordion-1">
                            <div class="grid columns-12 gap-6 mt-5">
                                <div class="intro-y g-col-12 g-col-lg-12">
                                    <div class="intro-y box p-5">
                                        <div class="row">
                                            <div class="col-md-3">
                                                <div>
                                                    <label for="crud-form-1" class="form-label font-weight-bold"> Name</label>
                                                    <input id="crud-form-1" type="text" onKeyPress={handleKeyPress} onChange={handleFilter} value={filter?.name ?? ''} name="name"
                                                        class="form-control w-full " placeholder="Enter  Name" />
                                                </div>
                                            </div>
                                            <div class="col-md-3">
                                                <div>
                                                    <label for="crud-form-1" class="form-label font-weight-bold"> Email</label>
                                                    <input id="crud-form-1" type="text" onKeyPress={handleKeyPress} onChange={handleFilter} value={filter?.email} name="email"
                                                        class="form-control w-full " placeholder="Enter Email" />
                                                </div>
                                            </div>
                                            <div class="col-md-2">
                                                <div>
                                                    <label for="crud-form-1" class="form-label font-weight-bold">Mobile No.</label>
                                                    <input id="crud-form-1" type="text" onKeyPress={handleKeyPress} onChange={handleFilter} value={filter?.customerMobile} name="customerMobile"
                                                        class="form-control w-full" placeholder="Enter Mobile No." />
                                                </div>
                                            </div>
                                        </div>
                                        <div class="text-end mt-5">
                                            <button type="submit" class="btn btn-elevated-primary w-24 me-2" onClick={() => filterSearch()}>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-search w-4 h-4 me-2"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>
                                                Search</button>
                                            <button onClick={handleClearFilter} type="button" class="btn btn-elevated-danger w-24"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x w-4 h-4 me-2"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg> Clear</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="intro-y g-col-12">
                            <div className='mt-2'>
                                <DataTable
                                    // title="Users"
                                    className="overflow-lg-visible"
                                    columns={columns}
                                    data={users && users.length > 0 ? users : []}
                                    progressPending={loading}
                                    progressComponent={<ThreeDots
                                        height="80"
                                        width="80"
                                        radius="9"
                                        color="#2d3748"
                                        ariaLabel="three-dots-loading"
                                        wrapperStyle={{ justifyContent: 'center', alignItems: 'center', height: '100%' }}
                                        wrapperClassName=""
                                        visible={loading}
                                    />}
                                    pagination
                                    paginationServer
                                    customStyles={customStyles}
                                    paginationTotalRows={usersPagination ? usersPagination : 0}
                                    onChangeRowsPerPage={(currentRowsPerPage) => setCurrentRowsPerPage(currentRowsPerPage)}
                                    onChangePage={(page) => onChangePage(page)}
                                />
                                {/* <DataTable
                                            className="overflow-lg-visible"
                                           columns={columns.map(column => ({
                                                    ...column,
                                                    cell: column.cell ? column.cell : (row) => (
                                                        <div>
                                                            {column.selector(row)}
                                                        </div>
                                                    ),
                                                }))}
                                            data={users && Object.keys(users).length > 0 ? users : []}
                                            striped={true}
                                            highlightOnHover={true}
                                            pagination={true}
                                            customStyles={customStyles}
                                            responsive={true}
                                            paginationServer={true}
                                            paginationTotalRows={users && users.length > 0 ? usersPagination.total : 0}
                                            onChangePage={(page) => onChangePage(page)}
                                            paginationRowsPerPageOptions={[10, 20, 50, 100]}
                                            onChangeRowsPerPage={(currentRowsPerPage, currentPage) => setCurrentRowsPerPage(currentRowsPerPage)}
                                            paginationPerPage={10}
                                        /> */}
                            </div>
                        </div>
                    </span>
                </div>
            </div>
        </React.Fragment >
    )
}

export default Users;